import { globalSettings } from '../../settings'

const { reactQuerySettings: appQuerySettings } = globalSettings

export { appQuerySettings }
